export default __webpack_public_path__ + "static/media/henry.d23adfc5.jpeg";